const SumStats = ({ data, info }) => {
    return (
        <section className="relative bg-blue-100 py-16 sm:py-24 lg:py-32 text-gray-800">
            <div className="w-full lg:w-[70%] lg:max-w-[1440px] mx-auto px-4 lg:px-0">
                <div className="py-4 text-center">
                    <h3 className="text-gray-800 font-semibold text-3xl sm:text-4xl xl:text-4xl">
                        {data.title}
                    </h3>
                </div>

                <div className="mt-8">
                    <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                        {data.items && data.items.map((item, idx) => (
                            <li
                                key={idx}
                                className="bg-white text-center border px-6 py-10 rounded-lg flex flex-col justify-center items-center min-h-[180px]"
                            >
                                <h4 className="text-3xl sm:text-4xl xl:text-4xl text-blue-500 font-bold">{item.data}</h4>
                                <p className="mt-3 text-gray-800 text-lg font-normal uppercase">{item.title}</p>
                            </li>
                        ))}

                        {/* Explore Now 项 - 与上面 item 一致样式 */}
                        <li className="bg-white text-center border px-6 py-10 rounded-lg flex justify-center items-center min-h-[180px] hover:bg-gray-100 transition">
                            <a href={data.link} className="flex items-center text-blue-500 font-semibold text-2xl">
                                Explore Now
                                <svg xmlns="http://www.w3.org/2000/svg" className="w-7 h-7 ml-2" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M2 10a.75.75 0 01.75-.75h12.59l-2.1-1.95a.75.75 0 111.02-1.1l3.5 3.25a.75.75 0 010 1.1l-3.5 3.25a.75.75 0 11-1.02-1.1l2.1-1.95H2.75A.75.75 0 012 10z" clipRule="evenodd" />
                                </svg>
                            </a>
                        </li>

                    </ul>
                </div>
            </div>
        </section>
    );
};

export default SumStats;
